import * as React from "react";
import { Col, FormGroup, Row } from "react-bootstrap";

import { adCopyStrategyTargetGroupLabels } from "../../../../../../../../label/ad-copy/activity";
import type { Choice } from "../../../../../../../../react-components/lu-component/src/index";
import { Checkboxes } from "../../../../../../../../react-components/lu-component/src/index";
import { adCopyAestheticMedicineExperienceMTOptions } from "../../../../../../../../server/models/ad-copy/activity";
import { AccordionForm } from "../../../../../parts/accodion-form";
import { TrueAdCopyStrategyGroup } from "../../../../../../types/ad-copy/activity";

type Props = {
	onChange: (name: keyof TrueAdCopyStrategyGroup, value: any) => void;
	strategyGroup: TrueAdCopyStrategyGroup;
};

export const AdCopyAestheticMedicineExperienceMTCheckboxes = React.memo((props: Props) => {
	const { onChange, strategyGroup } = props;
	const defaultShow = React.useMemo(() => {
		const { aestheticMedicineExperienceSpot, aestheticMedicineExperienceTone, aestheticMedicineExperienceAging } =
			strategyGroup;
		if (aestheticMedicineExperienceSpot != null && aestheticMedicineExperienceSpot.length) return true;
		if (aestheticMedicineExperienceTone != null && aestheticMedicineExperienceTone.length) return true;
		if (aestheticMedicineExperienceAging != null && aestheticMedicineExperienceAging.length) return true;
		return false;
	}, [strategyGroup]);
	return (
		<Row>
			<FormGroup as={Col}>
				<AccordionForm
					defaultShow={defaultShow}
					eventKey={"aestheticMedicineExperience"}
					title={adCopyStrategyTargetGroupLabels.aestheticMedicineExperience}
				>
					{/* 3つ並べる必要がある */}
					<Row style={{ paddingLeft: "15px" }}>
						{(
							[
								"aestheticMedicineExperienceSpot",
								"aestheticMedicineExperienceTone",
								"aestheticMedicineExperienceAging",
							] as const
						).map((key) => {
							return (
								<Col md={4} key={key}>
									{adCopyStrategyTargetGroupLabels[key]}
									<Checkboxes
										checkeds={strategyGroup[key] ?? []}
										choices={adCopyAestheticMedicineExperienceMTOptions as Choice[]}
										name={key}
										onChange={(value) => {
											onChange(key, value);
										}}
									/>
								</Col>
							);
						})}
					</Row>
				</AccordionForm>
			</FormGroup>
		</Row>
	);
});
